<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modal-nprofesion">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b> {{title}} </b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-center">
              <div class="form-group" :class="{'has-error': validation.hasError('area.nombre')}">
                <div class="input-group input-group-sm">
                  <div class="input-group-addon"> <span class="text-danger">*</span> Nombre</div>
                  <input type="text" v-model.trim="area.nombre" class="form-control" placeholder="Solo letras">
                  <span class="input-group-addon">Nombre de la Profesion</span>
                </div>
                <div class="error" v-if="validation.hasError('area.nombre')"> {{validation.firstError('area.nombre')}} </div>
              </div>
            </div>
            
            <Alertas ref="alertar" />
            <div class="modal-footer">
                <button @click="validarCampos" v-if="activo" type="button" class="btn btn-azul">Aceptar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
import gql from 'graphql-tag'
import { Validator } from 'simple-vue-validator'
    export default {
      props:{edit:{type:Object,required:false}},
        data(){
            return{
              area:{nombre:null},
              activo: true,
              title:'',
            }
        },
        watch:{},
        components:{Alertas},
        validators: {
          'area.nombre'(value){
              return Validator.value(value).required();
          },
        },
        methods:{
            hidden(){
                this.$refs.alertar.cargando();
            },
            llenar(){
              this.title = 'Registrar Nueva Profesion';
                if( !this.edit || !this.edit.id ) return;
                this.title = 'Editar Profesion';
                this.area.nombre = this.edit.nombre;
            },
             validarCampos(){
              this.$validate().then((success) => {
                var obj = window.Object.assign( {},this.area );
                  if (success) {
                    this.submit();
                  }else{
                    window.console.log( "HHHHH",window.stringifyObject(obj) );
                    this.$refs.alertar.invalido();
                  }
              });
            },
            submit(){
                if( this.edit && this.edit.id ){
                    this.actualizar();
                    return;
                }
                var vue = this;
                vue.$refs.alertar.cargando('Registrando...');
                vue.activo = false;
                var sql = gql`mutation{ createProfesion(input:${window.stringifyObject(this.area)}){ok,errors{message}}}`;

                this.$apollo.mutate({
                    mutation: sql,
                }).then((data) => {
                    window.console.log(data);
                    vue.$refs.alertar.success('Registrado');
                    this.$emit('exito');
                    vue.activo = true;
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                    vue.activo = true;
                })
            },
            actualizar(){
                this.msg = null;
                var sql = gql`mutation{ updateProfesion(input:{id:${this.edit.id},nombre:"${this.area.nombre}"}){ok,errors{message}} }`;
                var vue = this;
                vue.$refs.alertar.cargando('Actualizando...');
                vue.activo = false;
                this.$apollo.mutate({mutation: sql})
                .then((data) => {
                  if( data.data.updateProfesion){
                    vue.$refs.alertar.success('Actualizado');
                    this.$emit('exito');
                  }else{
                    var errores = JSON.stringify(data.data.updateProfesion.errors);
                    var obj = JSON.parse(errores);
                    var vals = "Error Desconocido";
                    if( obj != null ) obj.forEach(function(k) { vals += Object.values(k) + "-\n\t"; });
                    vue.msg = vals;
                  }
                    vue.activo = true;
                 
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            },
        },
        mounted(){
          const vue = this;
            window.$('#modal-nprofesion').on('shown.bs.modal',function(){ 
                vue.llenar();
            });
            window.$('#modal-nprofesion').on('hidden.bs.modal',function(){ 
                vue.area.nombre = null;
                vue.$refs.alertar.reset();
                window.console.log( '----' );
            });
        }
    
    }
</script>